/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Ci_CdInputs */

const en_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const ar_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التكامل والنشر المستمر`)
};

const bn_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const de_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const es_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const fr_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const pt_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const zh_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const tr_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const ru_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

const pl_svchip_ci_cd = /** @type {(inputs: Svchip_Ci_CdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI/CD`)
};

/**
* | output |
* | --- |
* | "CI/CD" |
*
* @param {Svchip_Ci_CdInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_ci_cd = /** @type {((inputs?: Svchip_Ci_CdInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Ci_CdInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_ci_cd(inputs)
	if (locale === "bn") return bn_svchip_ci_cd(inputs)
	if (locale === "de") return de_svchip_ci_cd(inputs)
	if (locale === "es") return es_svchip_ci_cd(inputs)
	if (locale === "fr") return fr_svchip_ci_cd(inputs)
	if (locale === "pt") return pt_svchip_ci_cd(inputs)
	if (locale === "zh") return zh_svchip_ci_cd(inputs)
	if (locale === "tr") return tr_svchip_ci_cd(inputs)
	if (locale === "ru") return ru_svchip_ci_cd(inputs)
	if (locale === "pl") return pl_svchip_ci_cd(inputs)
	return en_svchip_ci_cd(inputs)
});